/*
 *   Copyright (c) 2024
 *   All rights reserved.
 */
import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import styles from "assets/jss/material-dashboard-pro-react/components/tableStyle";

const useStyles = makeStyles(styles);

export default function FlexibleTable(props) {
  const classes = useStyles();

  const {
    tableHead,
    tableData,
    tableHeaderColor,
    hover,
    colorsColls,
    coloredColls,
    customCellClasses,
    customClassesForCells,
    striped,
    tableShopping,
    customHeadCellClasses,
    customHeadClassesForCells,
    maxHeight,
    handleClick,
    indexCol,
  } = props;

  const useStylesScrol = makeStyles({
    root: {
      width: "100%",
    },
    container: {
      maxHeight: maxHeight,
    },
  });

  const classesScrol = useStylesScrol();
  const onRowClick = (id, data) => {
    console.log("ID:", id);
    console.log("Data:", data);
    handleClick(id, data);
  };

  return (
    <div className={classes.tableResponsive}>
      <Paper className={classes.root}>
        <TableContainer className={classesScrol.container}>
          <Table className={classes.table}>
            {tableHead !== undefined ? (
              <TableHead className={classes[tableHeaderColor]}>
                <TableRow
                  className={classes.tableRow + " " + classes.tableRowHead}
                >
                  {tableHead.map((prop, key) => {
                    const tableCellClasses =
                      classes.tableHeadCell +
                      " " +
                      classes.tableCell +
                      " " +
                      cx({
                        [customHeadCellClasses[
                          customHeadClassesForCells.indexOf(key)
                        ]]: customHeadClassesForCells.indexOf(key) !== -1,
                        [classes.tableShoppingHead]: tableShopping,
                        [classes.tableHeadFontSize]: !tableShopping,
                      });
                    return (
                      <TableCell className={tableCellClasses} key={key}>
                        {prop}
                      </TableCell>
                    );
                  })}
                </TableRow>
              </TableHead>
            ) : null}
            <TableBody>
              {tableData?.map((row, key) => {
                // Récupération de l'ID et données
                const { id, data } = row; // Supposons que chaque ligne a { id, data }

                const tableRowClasses = cx({
                  [classes.tableRowBody]: true,
                  [classes.tableRowHover]: hover,
                  [classes[row.color + "Row"]]: row.color !== undefined,
                  [classes.tableStripedRow]: striped && key % 2 === 0,
                });

                return (
                  <TableRow
                    onClick={() => onRowClick(id, data)}
                    key={key}
                    hover={hover}
                    className={classes.tableRow + " " + tableRowClasses}
                  >
                    {data.map((cell, cellKey) => {
                      const tableCellClasses =
                        classes.tableCell +
                        " " +
                        cx({
                          [classes[colorsColls[coloredColls.indexOf(cellKey)]]]:
                            coloredColls.indexOf(cellKey) !== -1,
                          [customCellClasses[
                            customClassesForCells.indexOf(cellKey)
                          ]]: customClassesForCells.indexOf(cellKey) !== -1,
                        });

                      return (
                        <TableCell className={tableCellClasses} key={cellKey}>
                          {cell}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  );
}

FlexibleTable.defaultProps = {
  tableHeaderColor: "gray",
  hover: false,
  colorsColls: [],
  coloredColls: [],
  striped: false,
  customCellClasses: [],
  customClassesForCells: [],
  customHeadCellClasses: [],
  customHeadClassesForCells: [],
  maxHeight: "100%",
  handleClick: () => {},
  indexCol: 0,
};

FlexibleTable.propTypes = {
  tableHeaderColor: PropTypes.oneOf([
    "warning",
    "primary",
    "danger",
    "success",
    "info",
    "rose",
    "gray",
  ]),
  tableHead: PropTypes.arrayOf(PropTypes.string),
  // Of(PropTypes.arrayOf(PropTypes.node)) || Of(PropTypes.object),
  tableData: PropTypes.array,
  hover: PropTypes.bool,
  coloredColls: PropTypes.arrayOf(PropTypes.number),
  // Of(["warning","primary","danger","success","info","rose","gray"]) - colorsColls
  colorsColls: PropTypes.array,
  customCellClasses: PropTypes.arrayOf(PropTypes.string),
  customClassesForCells: PropTypes.arrayOf(PropTypes.number),
  customHeadCellClasses: PropTypes.arrayOf(PropTypes.string),
  customHeadClassesForCells: PropTypes.arrayOf(PropTypes.number),
  striped: PropTypes.bool,
  // this will cause some changes in font
  tableShopping: PropTypes.bool,
};
